import { IDocumentManagerPayload } from "../../interfaces/document-manager-api.interface";
import { useFormContext } from "react-hook-form";
import { ControlledTextFieldWithIcon } from "Components/HookForm/ControlledTextFieldWithIcon";
import { Button, Typography } from "@mui/material";
import { download } from "Components/DownloadButton";

export const DocumentInfo = ({ mode }: { mode: "Add" | "Edit" | "Info" }) => {
  const { control, getValues } = useFormContext<IDocumentManagerPayload>();

  function handleDownload(file_path: string) {
    download(file_path);
    console.log(`Download ${file_path}...`);
  }

  return (
    <>
      <ControlledTextFieldWithIcon name="_id" label="ID" control={control} variant="outlined" fullWidth disabled />
      <ControlledTextFieldWithIcon name="alias" label="Document Name" control={control} variant="outlined" fullWidth disabled={mode == "Info"} />
      <ControlledTextFieldWithIcon
        name="text_file.location"
        label="Processed Text File"
        control={control}
        variant="outlined"
        fullWidth
        disabled
        icon={
          <Button variant="contained" component="label" disabled={!getValues("text_file.available")} onClick={() => handleDownload(getValues("text_file.location"))}>
            Download
          </Button>
        }
      />
      <ControlledTextFieldWithIcon
        name="original_file.location"
        label="Original File"
        control={control}
        variant="outlined"
        fullWidth
        disabled
        icon={
          <Button variant="contained" component="label" disabled={!getValues("original_file.available")} onClick={() => handleDownload(getValues("original_file.location"))}>
            Download
          </Button>
        }
      />
      <Typography variant="body1" color="primary.main">
        Reference Settings
      </Typography>
      <ControlledTextFieldWithIcon name="reference.title" label="Reference Button Label" control={control} variant="outlined" fullWidth disabled={mode == "Info"} />
      <ControlledTextFieldWithIcon name="reference.link" label="Reference Link" control={control} variant="outlined" fullWidth disabled={mode == "Info"} />
      <ControlledTextFieldWithIcon name="CREATED_AT" label="Created At" control={control} variant="outlined" fullWidth disabled />
      <ControlledTextFieldWithIcon name="LASTMODIFIED" label="Last Modified Time" control={control} variant="outlined" fullWidth disabled />
    </>
  );
};
